import {
  createPersistedFlagStore,
  scopedFlagId,
} from 'utils/persistedFlagStore';

export const DISMISSED_TOAST_IDS = {
  usageLimit: 'usage_limit',
} as const;

export type DismissedToastId =
  typeof DISMISSED_TOAST_IDS[keyof typeof DISMISSED_TOAST_IDS];

const dismissedToasts = createPersistedFlagStore({
  storageKey: 'gumb_dismissed_app_toasts',
});

const userToastFlagId = (userId: string, toastId: DismissedToastId): string =>
  scopedFlagId(userId, toastId);

export const isAppToastDismissed = (
  userId: string,
  toastId: DismissedToastId,
): boolean => dismissedToasts.has(userToastFlagId(userId, toastId));

export const markAppToastDismissed = (
  userId: string,
  toastId: DismissedToastId,
): void => {
  dismissedToasts.set(userToastFlagId(userId, toastId));
};
